// Full updated file with CKEditor/PDF-matching UI styles
import React, { useEffect, useState } from "react";
import ModalComponent from "../../../../components/ModalComponent";

const TemplatePreviewModal = ({ show, onClose, template }) => {
  const [paginatedHtml, setPaginatedHtml] = useState("");

  useEffect(() => {
    if (!show || !template?.html_content) {
      setPaginatedHtml("");
      return;
    }

    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.left = "-9999px";
    container.style.top = "-9999px";
    container.style.width = "210mm";
    container.style.height = "auto";
    container.style.padding = "15mm";
    container.style.boxSizing = "border-box";
    container.style.visibility = "hidden";
    container.innerHTML = template.html_content;

    document.body.appendChild(container);

    try {
      const mmToPx = (mm) => Math.round(mm * 3.78);
      const PADDING_MM = 15;
      const CONTENT_HEIGHT_MM = 297 - PADDING_MM * 2;
      const contentHeightPx = mmToPx(CONTENT_HEIGHT_MM);
      const pages = [];
      let currentPageContent = [];
      let currentPageHeight = 0;

      const children = Array.from(container.childNodes);

      children.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const temp = document.createElement("div");
        temp.style.width = "210mm";
        temp.style.padding = "15mm";
        temp.style.position = "absolute";
        temp.style.visibility = "hidden";
        const clone = node.cloneNode(true);
        temp.appendChild(clone);
        document.body.appendChild(temp);
        const elementHeight = temp.offsetHeight - mmToPx(PADDING_MM * 2);
        document.body.removeChild(temp);

        if (currentPageHeight + elementHeight > contentHeightPx && currentPageContent.length > 0) {
          pages.push(currentPageContent);
          currentPageContent = [];
          currentPageHeight = 0;
        }

        currentPageContent.push(node.cloneNode(true));
        currentPageHeight += elementHeight;
      });

      if (currentPageContent.length) pages.push(currentPageContent);

      const html = pages
        .map((pageEls) => {
          const pageDiv = document.createElement("div");
          pageDiv.className = "a4-page";
          pageEls.forEach((el) => pageDiv.appendChild(el));
          return pageDiv.outerHTML;
        })
        .join("");

      setPaginatedHtml(html);
    } catch (err) {
      setPaginatedHtml(template.html_content || "");
    } finally {
      document.body.removeChild(container);
    }
  }, [show, template]);

  return (
    <ModalComponent
      show={show}
      handleClose={onClose}
      title={template?.title || "Template Preview"}
      footerButtons={[{ label: "Close", variant: "secondary", onClick: onClose }]}
      size="lg"
    >
      <div className="template-preview-body">
        {template ? (
          <div
            id="a4-preview-container"
            className="template-preview-content"
            dangerouslySetInnerHTML={{
              __html: paginatedHtml || template.html_content || "<p>No preview available</p>",
            }}
          />
        ) : (
          <p>No preview available</p>
        )}
      </div>

      <style jsx>{`
        .template-preview-body {
    
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #f4f5f7;
        }

        .a4-page > * {
          page-break-inside: avoid;
        }

        strong { font-weight: bold; }
        ul, ol { margin-left: 25px; }
        h1 { font-size: 24px; font-weight: 600; }
        h2 { font-size: 20px; font-weight: 600; }
        h3 { font-size: 18px; font-weight: 600; }
        h4 { font-size: 16px; font-weight: 600; }

        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          border: 1px solid black;
          padding: 6px 8px;
        }

        .marker-yellow { background: yellow; }
        .marker-green { background: #c8e6c9; }
        .marker-pink { background: pink; }
        .marker-blue { background: lightblue; }
        .pen-red { color: red; }
        .pen-green { color: green; }

        blockquote {
          border-left: 4px solid #ccc;
          padding: 10px 20px;
          background: #fafafa;
          margin: 15px 0;
          font-style: italic;
        }
          
        @media print {
          .a4-page {
            width: 210mm;
            min-height: 297mm;
            padding: 20mm;
            box-shadow: none;
            border-radius: 0;
          }
        }
      `}</style>
    </ModalComponent>
  );
};

export default TemplatePreviewModal;
